import React, { Component } from 'react';
import axios from 'axios';
import DataTable from './data-table';
import DataTableNotas from './data-table-notas';
import DataTableBlog from './data-table-blog';

export default class Blog extends Component {

    constructor(props) {
        super(props);
        this.state = { blogCollection: [] };
    }

    componentDidMount() {
        //var url = "https://aguitech.casidios.com/panel/ws_notas_react.php";
        var url = "https://aguitech.casidios.com/panel/ws_blog_react.php";
        var params = {
            data1: 'holamundo',
        }
        //axios.get('http://aguitech.casidios.com/panel/ws_notas_react.php')
        axios.post(url, params)
            .then(res => {
                //console.log()
                //this.setState({ usersCollection: res.data });
                console.log(res.data.resultado);
                this.setState({ blogCollection: res.data.resultado });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    dataTable() {
        return this.state.blogCollection.map((data, i) => {
            return <DataTable obj={data} key={i} />;
        });
    }
    dataTableNotas() {
        return this.state.blogCollection.map((data, i) => {
            return <DataTableNotas obj={data} key={i} />;
        });
    }
    dataTableBlog() {
        return this.state.blogCollection.map((data, i) => {
            return <DataTableBlog obj={data} key={i} />;
        });
    }

    render() {
        return (
            <div className="wrapper-users">
                <div className="container">
                    <table className="table table-striped table-dark">
                        <thead className="thead-dark">
                            <tr>
                                <td>ID</td>
                                <td>Name</td>
                                <td>Email</td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.dataTableBlog()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
/*
{this.dataTable()}
*/